import React, { createContext, useContext, useState, Dispatch, SetStateAction, ReactNode } from 'react';
import { Cards2f1FieldsFragment } from 'types/generated';

interface TwoForOneContextType {
  activeCard: Cards2f1FieldsFragment | null;
  setActiveCard: Dispatch<SetStateAction<Cards2f1FieldsFragment | null>>;
}

const TwoForOneContext = createContext<TwoForOneContextType | undefined>(undefined);

export const useTwoForOneContext = () => {
  const context = useContext(TwoForOneContext);
  if (!context) {
    throw new Error('useTwoForOneContext must be used within a TwoForOneProvider');
  }
  return context;
};

interface TwoForOneProviderProps {
  children: ReactNode;
}

export const TwoForOneProvider: React.FC<TwoForOneProviderProps> = ({ children }) => {
  const [activeCard, setActiveCard] = useState<Cards2f1FieldsFragment | null>(null);

  return <TwoForOneContext.Provider value={{ activeCard, setActiveCard }}>{children}</TwoForOneContext.Provider>;
};
